export default __webpack_public_path__ + "static/media/logo.18a15ab4.svg";